import { assertIsError } from '../../utils/assert-is-error';
import { getStorageKey, isStorageKey } from './storage-key';
const outOfSpaceStorageErrorNames = ['QUOTA_EXCEEDED_ERR', 'NS_ERROR_DOM_QUOTA_REACHED', 'QuotaExceededError'];
export const isOutOfSpaceStorageError = (error) => outOfSpaceStorageErrorNames.includes(error.name);
export const isStorageSupported = (storage) => {
    const testStorageKey = getStorageKey('test-key');
    const testValue = 'TestValue';
    try {
        storage.setItem(testStorageKey, testValue);
    }
    catch (error) {
        assertIsError(error);
        return isOutOfSpaceStorageError(error); // All other errors indicate that the storage is not working
    }
    try {
        const storedValue = storage.getItem(testStorageKey);
        if (storedValue !== testValue)
            return false;
        storage.removeItem(testStorageKey);
    }
    catch (error) {
        return false;
    }
    return true;
};
export const resetStorage = (storage) => {
    Object.keys(storage)
        .filter(isStorageKey)
        .forEach(key => storage.removeItem(key));
};
